import { Badge, Tooltip } from 'antd'
import React, { ReactNode } from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'

type Props = {
  organizationMember: OrganizationMemberFromContext
  children: ReactNode
  translateX?: number
  translateY?: number
}

export const BadgeStatus: React.FC<Props> = ({
  organizationMember,
  children,
  translateX = 25,
  translateY = 30,
}) => {
  const status = organizationMember?.appSession?.status ?? 'ACTIVE'

  const toOnboard = status === 'TO_ONBOARD'
  const isDisabled = status === 'DISABLED'

  const color = isDisabled ? 'grey' : 'green'
  const count = isDisabled ? ' ' : null
  const title = toOnboard
    ? 'Ready to onboard'
    : isDisabled
      ? 'Renew your subscription to activate'
      : null

  return (
    <Tooltip title={title} placement="right" mouseEnterDelay={1}>
      <Badge
        count={count}
        color={color}
        size="small"
        styles={{
          indicator: {
            minWidth: '10px',
            height: '10px',
            insetInlineEnd: 'unset',
            transform: `translateY(${translateY}px) translateX(${translateX}px)`,
          },
        }}
      >
        {children}
      </Badge>
    </Tooltip>
  )
}
